<template>
    <span>{{ tweeningValue }}</span>
</template>

<script>
    import { tween } from 'femtotween'

    export default {
        name: "AnimatedInteger",
        props: {
            value: {
                type: Number,
                required: true
            },
            mode: {
                default: ""
            }
        },
        data() {
            return {
                tweeningValue: 0,
                lastValue: 0
            }
        },
        watch: {
            value: function (newValue, oldValue) {
                this.lastValue = oldValue;
                if(this.mode=="manual") return;
                tween(oldValue, newValue, (v) => { this.tweeningValue = v.toLocaleString('de-DE',{ minimumFractionDigits: 0, maximumFractionDigits: 0 }) })
            }
        },
        mounted: function () {
            let self = this;
            tween(this.lastValue, this.value, (v) => { self.tweeningValue = v.toLocaleString('de-DE',{ minimumFractionDigits: 0, maximumFractionDigits: 0 }) });
        },
        methods: {
            start: function(){
                let self = this;
                // alert('tweene von 0 zu ' + this.value);
                tween(this.lastValue, this.value, (v) => { self.tweeningValue = v.toLocaleString('de-DE',{ minimumFractionDigits: 0, maximumFractionDigits: 0 }) });
            }
        }

    }
</script>

<style scoped>

</style>
